import * as React from "react";
import ProjectDetail from "./projectDetail";

export default function FailedProjects() {
  return <ProjectDetail live={false} />;
}
